import React, { useState, useEffect } from "react";
import {
  Text,
  Box,
  Group,
  Drawer,
  Select,
  ScrollArea,
  Button,
  NumberInput,
  Alert
} from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

import PremiumModal from "../../../app/PremiumModal";

import TriggerModel from "../../../../models/EngagementTrigger";
import SurveyModel from "../../../../models/Survey";
import BundleModel from "../../../../models/Bundle";

export default function AddTrigger({
  onUpdateTriggers,
  oriFunctions,
  functions,
  functionsType
}) {
  const { t } = useTranslation();

  const space = useSelector((state) => state.space);

  const [trigger, setTrigger] = useState(null);
  const [opened, setOpened] = useState(false);
  const [params, setParams] = useState([]);
  const [surveys, setSurveys] = useState([]);
  const [bundles, setBundles] = useState([]);
  const [selectedFunction, setSelectedFunction] = useState({ params: [] });

  const selectedFunctionParams = Array.isArray(selectedFunction?.params) ? selectedFunction.params : [];
  const isBundleTrigger = !!selectedFunctionParams.find((t) => t.type === "bundle");
  const isSurveyTrigger = !!selectedFunctionParams.find((t) => t.type === "survey");

  useEffect(() => {
    onFetchSurveys();
    onFetchBundles();
  }, []);

  useEffect(() => {
    if (!trigger) return;
    setParams([]);
    setSelectedFunction({ params: [] });
    getSelectTrigger();
  }, [trigger]);

  const onCreate = () => {
    const trigger_params = {};

    for (let i = 0; i < params.length; i++) {
      const ele = params[i];
      trigger_params[ele.key] = ele.value;
    }

    TriggerModel.onCreate(
      space.slug,
      trigger,
      trigger_params,
      functionsType,
      (data) => {
        setOpened(false);
        onUpdateTriggers(true);
      },
      (data) => {
        Swal.fire(t("errors.basic"), data.message, "error");
      }
    );
  };

  const getSelectTrigger = () => {
    const _selectedFunction = oriFunctions.filter(
      (item) => item.slug == trigger
    )[0];
    if (_selectedFunction) {
      setSelectedFunction(_selectedFunction);

      setParams(
        _selectedFunction.params.map((item) => ({
          value: item.default,
          key: item.key,
        }))
      );
    }
  };

  const onSetParamsValue = (index, val) => {
    const aux = [...params];
    aux[index].value = val;
    setParams(aux);
  };

  const onFetchSurveys = () => {
    SurveyModel.onFetch(
      space.slug,
      { page: 1, per: 100 },
      (data) => {
        const _surveys = data.data.map((item) => ({
          value: `${item.id}`,
          label: item.title,
          group: "Select an existing survey or quiz",
        }));
        setSurveys([..._surveys]);
      },
      (err) => {}
    );
  };

  const onFetchBundles = () => {
    BundleModel.onFetch(
      space.slug,
      (data) => {
        if (Array.isArray(data)) {
          const _bundles = data.map((item) => ({
            value: `${item.id}`,
            label: item.name,
            group: "Select an existing bundle",
          }));
          setBundles(_bundles);
        }
      },
      (err) => {}
    );
  };

  return (
    <Box mt={25}>
      <Button radius={"xl"} onClick={() => setOpened(true)}>
        {"Add trigger"}
      </Button>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        title={
          <Text size="xl" weight="800">
            {"Add trigger"}
          </Text>
        }
        padding="xl"
        size={600}
        offsetScrollbars
      >
        <ScrollArea style={{ height: "100%" }}>
          <Select
            label={"Select trigger"}
            value={trigger}
            onChange={setTrigger}
            placeholder={"Select trigger"}
            data={functions}
            maxDropdownHeight={400}
            radius="sm"
            size="md"
          />
          {selectedFunctionParams.map((item, index) => {
            return (
              <>
                {params[index] && item.type == "integer" && (
                  <NumberInput
                    mt={20}
                    defaultValue={item.default}
                    placeholder={item.placeholder}
                    label={item.label}
                    value={params[index].value}
                    onChange={(val) => onSetParamsValue(index, val)}
                    radius="sm"
                    size="md"
                  />
                )}
                {params[index] && item.type == "survey" && surveys.length > 0 && (
                  <Select
                    defaultValue={item.default}
                    placeholder={item.placeholder}
                    maxDropdownHeight={400}
                    radius="sm"
                    size="md"
                    mt={20}
                    data={surveys}
                    value={params[index].value}
                    onChange={(val) => onSetParamsValue(index, val)}
                  />
                )}
                {params[index] && item.type == "bundle" && bundles.length > 0 && (
                  <Select
                    defaultValue={item.default}
                    placeholder={item.placeholder}
                    maxDropdownHeight={400}
                    radius="sm"
                    size="md"
                    mt={20}
                    data={bundles}
                    value={params[index].value}
                    onChange={(val) => onSetParamsValue(index, val)}
                  />
                )}
              </>
            );
          })}
          {(isBundleTrigger && bundles.length === 0) || (isSurveyTrigger && surveys.length === 0) ? (
            <Alert color="gray" radius="md" mt={20}>
              {`You haven’t created any ${isBundleTrigger ? "bundles" : "surveys"} yet.`}
            </Alert>
          ) : (
            <Group position="apart" mt={20}>
              <Button radius={"xl"} onClick={() => onCreate()}>
                {"Save trigger"}
              </Button>
            </Group>
          )}
          <Box mt={100} />
        </ScrollArea>
      </Drawer>
      <PremiumModal opened={opened} setOpened={setOpened} />
    </Box>
  );
}
